import React from 'react';
import './featureContent.css';

/**
 * Grid of checkmarked bullet items.
 * @param {string[]} items
 */
function FeatureListGrid({ items }) {
    return (
        <div className="fc-list-grid">
            {items.map((item) => (
                <div className="fc-list-item" key={item}>
                    <span className="fc-list-item-tick">✓</span>
                    <span>{item}</span>
                </div>
            ))}
        </div>
    );
}

export default FeatureListGrid;
